/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `ScheduleIconProps` interface defines the properties for the ScheduleIcon component.
 */
interface ScheduleIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "schedule" — outlined, weight 300.
 * Clock icon for duration / time display.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const ScheduleIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'ScheduleIcon',
    width
}: ScheduleIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m612-292 56-56-148-148v-184h-60v204l152 184ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 340q140 0 230-90t90-230q0-140-90-230t-230-90q-140 0-230 90t-90 230q0 140 90 230t230 90Z" />
    </svg>
);

ScheduleIcon.displayName = 'ScheduleIcon';